import React, { Component } from 'react'

class CompanyName extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company: {
                title: '',
            },
            states: [],
            submitted: false,
        }
        this.onChange = this.onChange.bind(this);
        // this.props.getAllCountriesCall;
    }

    // componentWillMount() {
    //     this.setState({
    //         company: {
    //             ...this.state.company,
    //             title: this.props.companyProp
    //         }
    //     });
    // }

    componentDidMount() {
        this.setState({
            company: {
                ...this.state.company,
                title: this.props.companyProp
            }
        });
    }


    onChange(e) {
        this.setState({
            company: {
                ...this.state.company,
                [e.target.name]: e.target.value
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.company.title !== prevState.company.title) {
            this.props.returnState({
                // addressObj: this.state.addressObject
                title: this.state.company.title
            })
        }
    }
    render() {
        const { title } = this.state.company;
        return (
            <div className="mt-md fullWidth fieldWithIcon">
                <span className="fieldIcon companyIcon"></span>
                <input type="text" name="title" className="form-control" placeholder="Company" value={title || ''} onChange={this.onChange} />
                {/* {this.validatorCustomer.message('title', title, 'required')} */}
                {
                    this.props.requiredField.title &&
                    <span className="customMsg">
                        {this.props.validatorInstance.message('Company Title', title, this.props.requiredField.title)}
                    </span>
                }
            </div>
        )
    }
}


export default CompanyName;



// WEBPACK FOOTER //
// ./src/components/Admin/Customers/CompanyName.jsx